import { CurrencyPipe } from "@angular/common";
import { AuditEntity } from "@app/common";
import { UnitPrice } from "@app/core";
import { Column, Display } from "@messaia/cdk";

export class BillItem extends AuditEntity {
    /**
     * @property
     */
    @Column()
    @Display($localize`:@@name:Name`)
    public name: string;

    /**
     * @property
     */
    @Column({
        filterOperator: '~',
        width: 90,
        showGtMd: true
    })
    @Display($localize`:@@number:Number`)
    public number: number;

    /**
     * @property
     */
    @Column({
        name: 'price.net',
        content: (x: BillItem) => new CurrencyPipe('de-DE', '€').transform(x.price?.net ?? 0),
        width: 90,
        showGtMd: true
    })
    @Display($localize`:@@net:Net`)
    private net: number;

    /**
     * @property
     */
    @Column({
        name: 'price.gross',
        content: (x: BillItem) => new CurrencyPipe('de-DE', '€').transform(x.price?.gross ?? 0),
        width: 90,
        showGtMd: true
    })
    @Display($localize`:@@gross:Gross`)
    private gross: number;

    /**
     * @property
     */
    @Column({
        name: 'price.taxAmount',
        content: (x: BillItem) => new CurrencyPipe('de-DE', '€').transform(x.price?.taxAmount ?? 0),
        width: 120,
        showGtMd: true
    })
    @Display($localize`:@@e977c957564894ae20b3abf6da0c018b8eb2ddd2:Tax`)
    private taxAmount: number;

    /**
     * @property
     */
    public price: UnitPrice = new UnitPrice();

    /**
     * @property
     */
    public nameIntern: string;

    /**
     * @property
     */
    public quantity: number = 1;

    /**
     * @property
     */
    public productId: number | null;

    /**
     * @property
     */
    public itemBundleId: number;
}